"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openMotivationVideo = exports.initMotivationAd = exports.init = exports.AmsRewardVideoStatusChangeHandle = exports.getParams = void 0;
const tools_1 = require("../utils/tools");
const logger_1 = require("../utils/logger");
const getAds_1 = require("../utils/getAds");
const type_1 = require("../type");
const getSdkInfo = () => new Promise((resolve) => {
    var _a, _b;
    if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.getADDeviceInfo) {
        window.browser.ad.getADDeviceInfo((res) => {
            if (Number(res.code) === 0) {
                resolve(res);
            }
            else {
                (0, logger_1.logInfo)(`GETADDEVICEINFO-RETCODE-${res.code}`);
                resolve(null);
            }
        }, {
            type: 0,
        });
    }
    else {
        resolve(null);
    }
});
const getParams = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const amsSdkInfo = yield getSdkInfo();
        (0, logger_1.logInfo)('GET_AMSSDK_INFO');
        if (amsSdkInfo) {
            (0, logger_1.logInfo)('GET_AMSSDK_INFO_SUCCESS', JSON.stringify(amsSdkInfo));
            const [deviceInfo, wxVersionName = '', qqVersionName = '', loginInfo] = yield Promise.all([
                (0, tools_1.getAndroidDeviceInfo)(),
                (0, tools_1.getWxPkgVersion)(),
                (0, tools_1.getQQPkgVersion)(),
                (0, tools_1.getLoginData)(),
            ]);
            const lastAds = (0, tools_1.getLastAds)();
            const { androidId, macAddr, oaid, taid, imei } = deviceInfo;
            const { type, uin } = loginInfo || {};
            return {
                lastAds,
                supportHttps: location.protocol.indexOf('https') > -1 ? '1' : '0',
                taid,
                oaid,
                imei,
                androidId,
                macAddr,
                wxVersionName,
                qqVersionName,
                type,
                uin,
                amsSdkInfo: JSON.stringify((_a = amsSdkInfo) === null || _a === void 0 ? void 0 : _a.deviceInfo),
            };
        }
        return null;
    }
    catch (err) {
        (0, logger_1.logInfo)('GET_PARAMS_CATCH', JSON.stringify(err));
        (0, tools_1.showToast)('GET_PARAMS_CATCH');
        return null;
    }
});
exports.getParams = getParams;
const requestAd = (initParams) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const params = yield (0, exports.getParams)();
        if (!params) {
            (0, tools_1.showToast)('获取广告参数失败');
            (0, logger_1.logInfo)('GET_ADS_PARAMS_FAIL_ON_REQUESTAD');
            return;
        }
        (0, logger_1.logInfo)(`REQUESTAD-${initParams.appId}-${initParams.posId}`);
        const stUser = yield (0, getAds_1.getStUser)();
        const body = Object.assign(Object.assign(Object.assign({}, params), initParams), { stUser });
        const ads = yield (0, getAds_1.getAds)(body, initParams.env);
        const [ad] = ads;
        if (!ad)
            return null;
        const mAdsCommodityInfoExt = ad.adsCommodityInfoExt;
        const { ams_sdk_rsp: amsSdkRsp = '{}', report_ams_pos_id: reportAmsPosId = 0 } = mAdsCommodityInfoExt;
        return {
            posid: reportAmsPosId,
            amsData: amsSdkRsp,
        };
    }
    catch (err) {
        (0, logger_1.logInfo)('REQUEST_AD_CATCH', JSON.stringify(err));
        (0, tools_1.showToast)('REQUEST_AD_CATCH');
    }
});
const AmsRewardVideoStatusChangeHandle = (setRsp, params) => {
    if (setRsp.data === type_1.AmsRewardVideoStatus.onADClick) {
        if (params.onADClickCallback) {
            params.onADClickCallback();
        }
    }
    if (setRsp.data === type_1.AmsRewardVideoStatus.OnADShow) {
        if (params.onADShowCallback) {
            params.onADShowCallback();
        }
    }
    if (setRsp.data === type_1.AmsRewardVideoStatus.OnADClose) {
        if (params.onADCloseCallback) {
            params.onADCloseCallback();
        }
    }
};
exports.AmsRewardVideoStatusChangeHandle = AmsRewardVideoStatusChangeHandle;
const getSdkData = (adData, params) => {
    const sdkData = {
        posId: adData.posid,
        adData: adData.amsData,
    };
    const configKeyArr = [
        'unmetTipsText',
        'hasDoneTipsText',
        'dialogText',
        'rightButtonText',
        'leftButtonText',
        'videoShorterThanRewardTipsText',
        'gainRewardTime',
    ];
    for (const [key, value] of Object.entries(params)) {
        if (configKeyArr.includes(key)) {
            sdkData[key] = value;
        }
    }
    return sdkData;
};
const setAndShowInSdk = (adData, callback, params) => {
    var _a, _b;
    if ((_b = (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.ad) === null || _b === void 0 ? void 0 : _b.setAmsRewardVideoAD) {
        const sdkData = getSdkData(adData, params);
        window.browser.ad.setAmsRewardVideoAD((setRsp) => {
            var _a;
            callback(setRsp);
            if (setRsp && (setRsp.code === 0 || setRsp.code === '0')) {
                if (setRsp.data === type_1.AmsRewardVideoStatus.OnVideoCached) {
                    (_a = window === null || window === void 0 ? void 0 : window.browser) === null || _a === void 0 ? void 0 : _a.ad.showAmsRewardVideoAD(() => { }, {
                        posId: adData.posid,
                    });
                }
                (0, exports.AmsRewardVideoStatusChangeHandle)(setRsp, params);
            }
        }, sdkData);
    }
};
const init = (params, callback) => __awaiter(void 0, void 0, void 0, function* () {
    let amsData = yield requestAd(params);
    if (!amsData) {
        amsData = yield requestAd(params);
        (0, logger_1.logInfo)(`REQUESTAD-first-FAIL-${params.appId}-${params.posId}`);
    }
    if (!amsData) {
        (0, logger_1.logInfo)(`REQUESTAD-SECOND-FAIL-${params.appId}-${params.posId}`);
        callback({
            code: 0,
            data: type_1.AmsRewardVideoStatus.OnLoadAdFail,
            errMsg: 'adLoadFail',
            posId: params.posId.toString(),
        });
        (0, tools_1.showToast)(`请求接口失败-appId: ${params.appId}-posId: ${params.posId}`);
    }
    if (amsData) {
        setAndShowInSdk(amsData, callback, params);
    }
});
exports.init = init;
const initMotivationAd = (params, callback) => {
    (0, logger_1.logInfo)('INITMOTIVATION-AD-FUNCTION-CALLED', JSON.stringify({ params }));
    (0, exports.init)(params, (res) => {
        if (res && (Number(res.code) === 0 && res.data === type_1.AmsRewardVideoStatus.OnReward)) {
            callback(res);
        }
        else {
            callback(res);
        }
    });
};
exports.initMotivationAd = initMotivationAd;
const initMotivationAdFn = (0, tools_1.debounce)(exports.initMotivationAd, 1000, true);
const openMotivationVideo = (params, succCallback, options) => {
    initMotivationAdFn(Object.assign(Object.assign({}, params), { posId: params.posId, appId: params.appId }), (res) => {
        switch (res.data) {
            case type_1.AmsRewardVideoStatus.OnReward:
                succCallback === null || succCallback === void 0 ? void 0 : succCallback(res);
                break;
            case type_1.AmsRewardVideoStatus.OnLoadAdFail:
                (0, logger_1.logInfo)('OPENMOTIVATIONVIDEO_ON_LOADADFAIL', JSON.stringify(res));
                (options === null || options === void 0 ? void 0 : options.onLoadAdFail) ? options.onLoadAdFail(res) : (0, tools_1.showToast)('视频加载失败，请重试');
                break;
            case type_1.AmsRewardVideoStatus.OnError:
                (0, logger_1.logInfo)('OPENMOTIVATIONVIDEO_ON_ERROR', JSON.stringify(res));
                (options === null || options === void 0 ? void 0 : options.onError) ? options.onError(res) : (0, tools_1.showToast)('视频加载异常，请重试');
                break;
        }
    });
};
exports.openMotivationVideo = openMotivationVideo;
//# sourceMappingURL=index.js.map